import React, { useContext } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

//styles
import { ImgPulse, NoAlarmContainer } from "./Pulse.elements";

//images
import pulseDefault from "../../img/numeric/pulse/PulseNoAlarm.png";
import pulseAlarmLimitsEcgOff from "../../img/numeric/pulse/PulseAlarmLimits.png";
import noAlarmIcon from "../../img/icons/noalarm.png";

import noAlarmIcon2 from "../../img/icons/noalarm2.jpg";
import pulseDefault2 from "../../img/numeric/pulse/Pulse_noalarm.png";
import pulseBlank from "../../img/numeric/pulse/PulseBlank.png";
import { ContainerDiv, NoAlarmImg } from "./RR.elements";

const Pulse = ({ landscape }) => {
  const { state, setState } = useContext(AppContext);

  return (
    <Link to="/settings/pulse" style={{ position: "relative" }}>
      {state.ecg === false ? (
        <ImgPulse src={pulseAlarmLimitsEcgOff} />
      ) : (
        <>
          <ImgPulse src={pulseDefault2} />
          {/* <ContainerDiv landscape={landscape}>
            <img src={noAlarmIcon2} alt="" />
          </ContainerDiv> */}
        </>
      )}
    </Link>
  );
};

export default Pulse;
